<template>
    <div class="scrollListFBBox">
        <div class="noticeTitle line_right">公告</div>
        <div class="scrollListBox">
            <van-swipe class="scrollList" style="height: 1.44rem;" :touchable="false" :autoplay="3000" :show-indicators="isShowIndicators" :vertical="isVertical">
                <van-swipe-item v-for="(item, index) in noticeList" :key="index">
                    <div class="scrollListItem">
                        <div class="itemLeft">
                            <div class="bageBox line_border">
                                <div class="locationBage">{{item.countyName}}</div>
                            </div>
                            <p class="noticeText">{{item.memo}}</p>
                        </div>
                        <div class="itemRight" v-show='item.noticeTime'>{{item.noticeTime | filtTime}}</div>
                    </div>
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
</template>

<script>
    import { Swipe, SwipeItem } from 'vant'

    export default {
        name: 'scrollListFB',
        props: {
            bannerList: {
                type: Array
            }
        },
        data () {
            return {
                noticeList: [
                    //  {countyName: '昆明市 五华区', memo: '[昆明市五华区超荣小吃店] 已下线规范指数扣分 [3分]', noticeTime: 1576759750000},
                ],
                isShowIndicators: false,
                isVertical: true
            }
        },
        mounted () {
            this.getDataList()
        },
        methods: {
            getDataList () {
                this.noticeList = this.bannerList
            }
        },
        filters: {
            filtTime (str) {
                var date = new Date(str);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                let strDate = Y + M + D + h + m + s;
                return strDate;
            }
        }
    }
</script>

<style lang="less" scoped>
    .scrollListFBBox{
        width: 100%;
        height: 78px;
        margin: 12px 0;
        background-color: #fff;
        box-shadow:0px 0px 10px 0px rgba(0,0,0,0.04);
        box-sizing: border-box;
        border-radius: 3px;

        .noticeTitle{
            // border-right: 1px solid #eeeeee;
            width: 48px;
            text-align: center;
            height: 100%;
            line-height: 78px;
            float: left;
        }

        .scrollListBox{
            padding: 0 4px 0 12px;
            height: 78px;
            color: #999;
            box-sizing: border-box;
            overflow: hidden;

            .scrollList{
                // margin-top: 0px;
                margin-top: 13px;
                transition: margin-top .5s;
                -moz-transition: margin-top .5s;
                -webkit-transition: margin-top .5s;
                -o-transition: margin-top .5s;

                .scrollListItem{
                    height: 54px;
                    padding-top: 2px;
                    position: relative;

                    .itemLeft{
                        margin-right: 79px;
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);

                        .bageBox::after{
                            content: '';
                            display: block;
                            clear: both;
                        }

                        .bageBox{
                            .locationBage{
                                margin: 2px 3px 0 3px;
                                font-size: 10px;
                                color: #999;
                            }
                        }

                        .noticeText{
                            padding-top: 4px;
                            font-size: 12px;
                            color: #666;
                            line-height: 18px;
                            overflow: hidden;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2
                        }
                    }

                    .itemRight{
                        width: 79px;
                        height: 32px;
                        font-size: 12px;
                        text-align: center;
                        line-height: 16px;
                        position: absolute;
                        top: 11px;
                        right: 0;
                        color: #999;
                    }
                }
            }
        }
    }

    .scrollListFBBox::after{
        content: '';
        display: block;
        clear: both;
    }
</style>
